import { render, staticRenderFns } from "./PlacePlane.vue?vue&type=template&id=c15462f4"
import script from "./PlacePlane.vue?vue&type=script&lang=js"
export * from "./PlacePlane.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports